import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{add-body-classes \'SH-app--loading\'}}\n\n<AppLoader />\n",{ moduleName: "sh-www/templates/signout.hbs" })